import { render, staticRenderFns } from "./insUserModal.vue?vue&type=template&id=472b4f68&"
import script from "./insUserModal.vue?vue&type=script&lang=js&"
export * from "./insUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports